<template>
    <div>

        <div>
            <b-card-group deck>
                <b-card
                        header="Register with your email address here"
                        header-tag="header"
                        footer=""
                        footer-tag="footer"
                        title="Register Form"
                >
                        <b-form-group
                                id="exampleInputGroup1"
                                label="Email address:"
                                label-for="exampleInput1"
                                description="We'll never share your email with anyone else."
                        >
                            <b-form-input
                                    id="exampleInput1"
                                    type="email"
                                    v-model="form.email"
                                    required
                                    placeholder="Enter email"/>
                        </b-form-group>
                        <br/>
                        <div class="justify-content-center">
                            <vue-recaptcha :sitekey="this.sitekey" @verify="onVerify">
                              </vue-recaptcha>
                        </div>
<br/>



                        <!--<b-button type="button" variant="primary" @click="dotest"  >test</b-button>-->
                        <b-button type="button" variant="primary" @click="doRegister" :disabled="notNow" >Register New Account</b-button>
                </b-card>

            </b-card-group>
        </div>

        <!-- Modal Component -->
        <b-modal show ref="registerModal" id="modal1" title="Registration">
            <b-alert show v-html="form.server">
            </b-alert>
            <b-progress :value="counter" :max="max"  animated v-show="busy" />
            <div slot="modal-footer">
                <b-button v-on:click="hideRegister">Close</b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        data() {
            return {
                sitekey: '6LdS2ZIUAAAAAEh9E5s7X5mWTP2g2Xl5LwfErbQ3',
                form: {
                    email: '',
                    validated: false,
                    server: ''
                },
                show: true,
                errors: [],
                showServer: false,
                max: 100,
                counter: 100,
                busy: true
            }
        },
        created() {

        },
        computed: {
            notNow() {
                return !this.form.validated || this.form.email.length < 3;
            }
        },
        methods: {
            onVerify() {
                this.form.validated = true;
            },
            doRegister() {
                this.busy = true;
                this.$refs.registerModal.show()
                this.form.server = 'Searching for Units...'
                let email = this.form.email;
                let url = this.apihost + "rreqpass?fromname=" + email + "&frommail=" + email + "&user=" + email;
                let parent = this;
                axios.post(url)
                    .then(rs=>{
                        parent.busy = false;
                        if (rs.data.Result === 1) {
                            let foundText = "No Units Found!";
                            if (rs.data.List.length) {
                                foundText = "<br/>";
                                for (let item of rs.data.List) {
                                    foundText += item.rekno + " - " + item.Name + "<br/>";
                                }
                            }
                            parent.form.server = rs.data.Message + foundText
                        } else {
                            parent.form.server = rs.data.Message
                        }
                    })
                    .catch(e=>{
                        parent.busy = false;
                        parent.form.server = "Connection Error!"
                        console.log(e)
                    })
            },
            hideRegister() {
                this.$refs.registerModal.hide()
            },
        },
        components: {
            VueRecaptcha
        }
    }
</script>

<style>


</style>